import { useValue } from '@morningtrain/react-resources'

export default function Change ({ name }) {
  const value = useValue(name)

  const valueAsInt = parseInt(value)

  if (isNaN(valueAsInt)) {
    return 0
  }

  if (valueAsInt > 0) {
    return '+' + valueAsInt.toLocaleString()
  }

  return valueAsInt.toLocaleString()
}
